import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {FaIconLibrary} from '@fortawesome/angular-fontawesome';

import * as fas from "@fortawesome/free-solid-svg-icons";
import * as far from "@fortawesome/free-regular-svg-icons";

import {Amplify} from "aws-amplify";

import {environment} from '../environments/environment';

Amplify.configure({

  Auth: {
    Cognito: {
      userPoolClientId: '8voc7t1bhfcgk2gvbb7s1t1au',
      userPoolId: 'us-west-2_u7l9sv645',
      identityPoolId: "us-west-2:f0eaf4a7-81b5-4c77-8c95-388d9050251e",
      signUpVerificationMethod: "code",
      loginWith: {
        username: true,
        oauth: {
          domain: "gameface.auth.us-west-2.amazoncognito.com",
          scopes: [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
          ],
          redirectSignIn: [
            environment.uiHost + "/auth/callback",
          ],
          redirectSignOut: [
            environment.uiHost + "/signout"
          ],
          responseType: "code"
        }
      }
    },
  },
});



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent {
  title = 'GameFace';

  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIcons(
      fas.faHome,
      fas.faDice,
      fas.faCamera,
      fas.faEye,
      fas.faCrown,
      fas.faUserPlus,
      fas.faUserGroup,
      fas.faChalkboardUser,
      fas.faClock,
      fas.faMobileScreenButton,

      fas.faHeart,
      fas.faShield,

      fas.faExclamation,
      fas.faTriangleExclamation,
      fas.faTimes,
      fas.faCheck,
      fas.faFlag,
      fas.faStar,
      far.faStar,

      fas.faEllipsis,
      fas.faEllipsisVertical,

      fas.faFloppyDisk,
      fas.faFilePen,
      fas.faCopy,
      fas.faTrash,
      fas.faMagnifyingGlass,
      fas.faCloudArrowDown,
      fas.faNoteSticky,

      fas.faCircle,
      far.faCircle,
      fas.faCircleQuestion,
      fas.faCirclePlus,
      fas.faCircleMinus,
      fas.faTimesCircle,
      fas.faCircleCheck,
      fas.faCircleHalfStroke,
      fas.faCircleExclamation,
      fas.faCircleNotch,
      fas.faCirclePlay,
      fas.faCircleDown,
      fas.faCircleChevronDown,

      fas.faFaceMeh,
      fas.faFaceSmile,
      fas.faFaceGrinStars,
      fas.faFaceGrinBeamSweat,

      fas.faThumbsUp,
      fas.faThumbsDown,

      fas.faSquareMinus,
      fas.faSquarePlus,

      fas.faCaretLeft,
      fas.faCaretRight,
      fas.faCaretUp,
      fas.faCaretDown,
      fas.faRotateLeft,
      fas.faRotateRight,
      fas.faFilter,
      fas.faFilterCircleXmark,

      fas.faSquare,
      fas.faBold,
      fas.faItalic,
      fas.faCode,
      fas.faUnderline,
      fas.faStrikethrough,

      fas.faDoorClosed,
      fas.faPlay,
      fas.faPlus,
      fas.faBars,

      fas.faChevronLeft,
      fas.faChevronRight,
      fas.faSpinner
    )
  }
}
